import { Overlay } from "@angular/cdk/overlay";
import { Component } from "@angular/core";
import { ProductMtaAgreementModel } from "../../../models/components/product-mta-agreement.model";
import { ProductMtaPopUpService } from "../../../services/components/product-mta-pop-up.service";
import { DialogService } from "../../../services/components/dialog.service";
import { ProductPopUpBaseComponent } from "../product-pop-up-base/product-pop-up-base.component";

@Component({
    selector: "pcg-ng-product-mta-popup",
    template: require('./product-mta-pop-up.component.html')
})
export class ProductMtaPopUpComponent extends ProductPopUpBaseComponent<ProductMtaAgreementModel> {
    public constructor(
        popupService: ProductMtaPopUpService,
        overlay: Overlay,
        dialogService: DialogService
    ) {
        super(popupService, overlay, dialogService);
    }
}
